var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"64px"}}),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v("woshuoxia  2019 ~ 2024 "),_c('a',{staticStyle:{"color":"grey"},attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","_target":"_blank"},on:{"click":function($event){return _vm.toBeian()}}},[_vm._v("备案信息：蜀ICP备2020025859号-1")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff00f56c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 